
import React from 'react';
import { useAuth } from '../hooks/useAuth';

const roleNames = {
  owner: 'المالك',
  secretary: 'السكريتاريا',
  accountant: 'المحاسبة'
};

const Header = () => {
  const { user } = useAuth();
  
  return (
    <header className="bg-white shadow-md p-4 flex justify-between items-center">
      <div>
        {/* Placeholder for page title if needed */}
      </div>
      <div className="flex items-center">
        <div className="text-left">
          <div className="font-semibold text-gray-800">{user?.user.username}</div>
          <div className="text-sm text-gray-500">{roleNames[user?.role]}</div>
        </div>
      </div>
    </header>
  );
};

export default Header;
